import {ItemInterface, OfferInterface} from '@api/item';
import {UserInterface} from '@api/user';
import resolveImage from '@helpers/resolve-image';
import {acceptOffer, approvalForAll, isApprovedForAll} from '@helpers/web3';
import {CircularProgress} from '@mui/material';
import Tippy from '@tippyjs/react';
import {ethers} from 'ethers';
import {useForceCorrectNetwork} from 'hooks/force-correct-network';
import React, {useEffect, useState} from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

const AcceptOfferModal = ({
  openModal,
  onClose,
  offer,
  item,
  user,
}: {
  openModal: boolean;
  onClose: () => void;
  offer: OfferInterface;
  item: ItemInterface;
  user: UserInterface;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const forceCorrectNetwork = useForceCorrectNetwork();

  const _acceptOffer = async () => {
    console.log({
      _offerId: offer.id,
    });
    try {
      await forceCorrectNetwork();
      console.log(user?.wallet_address);
      setLoading(true);
      const isApproved = await isApprovedForAll(user?.wallet_address as string);
      if (!isApproved) {
        await approvalForAll();
      }

      const receipt = await acceptOffer({
        _offerId: offer.id,
      });
      console.log({receipt});
      setTimeout(() => {
        setIsSuccess(true);
        setLoading(false);
      }, 3000);
    } catch (error) {
      setIsError(true);
      setLoading(false);
      // BALNFT = you dont have enough NFT to accept this offer
      console.error(error);
      console.log('error');
    }
  };

  const handleAfterBuy = () => {
    setIsError(false);
    setIsSuccess(false);
  };

  const formatPrice = (price?: string) => {
    if (!price) return 0;
    return ethers.utils.formatUnits(price, offer.Currency.decimals);
  };

  const getTotalRoyalty = (item?: ItemInterface) => {
    if (!item) return 0;
    const totalRoyalty = item?.Collection.royalty.reduce((accum, r) => {
      return accum + r.percentage;
    }, 0);
    return totalRoyalty * 100;
  };

  return (
    <div>
      {/* <!-- Buy Now Modal --> */}
      <div className={openModal ? 'modal fade show block' : 'modal fade'}>
        <div className="modal-dialog max-w-2xl w-full absolute top-0 pb-10">
          <div className="modal-content !bg-none">
            <div className="modal-header border-b-0">
              <h5 className="modal-title" id="buyNowModalLabel">
                {isError ? (
                  <span className="text-red">FAILED</span>
                ) : isSuccess ? (
                  <span className="text-green">SUCCESS</span>
                ) : (
                  <span>Accept Offer</span>
                )}
              </h5>
              <button
                type="button"
                className={`btn-close ${loading && 'hidden'}`}
                onClick={() => {
                  handleAfterBuy();
                  onClose();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-dark-navy h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              {!isError && !isSuccess ? (
                <>
                  <div className=" dark:border-black-green border-light-grey relative flex items-center pb-8 border-b">
                    <div className="w-[150px] h-[150px] mr-6">
                      {item && (
                        <div
                          className="w-full pb-[100%] bg-center bg-no-repeat bg-cover rounded-3xl mx-auto"
                          style={{backgroundImage: `url('${resolveImage(item?.image)}')`}}
                        ></div>
                      )}
                    </div>

                    <div>
                      <span className="text-white text-[18px] font-display">
                        {item?.Collection?.name}
                      </span>
                      <h3 className="font-display mb-1 text-[18px] font-semibold text-grey">
                        {item?.name}
                      </h3>
                      <div className="flex flex-wrap items-center">
                        <span className="text-grey mr-1 block text-sm">
                          Creator Fee: {getTotalRoyalty(item)}%
                        </span>
                      </div>
                    </div>

                    <div className="ml-auto">
                      <span className="mb-1 items-center whitespace-nowrap">
                        <span className="dark:text-white font-bold tracking-tight">
                          {offer?.pricePerToken.replace('MATIC', '')}
                        </span>
                        {(item?.supply as number) > 1 && (
                          <span className="mb-1 ml-auto flex items-center justify-end whitespace-nowrap">
                            <span className="dark:text-white font-bold tracking-tight">
                              X {offer?.quantity}
                            </span>
                          </span>
                        )}
                      </span>
                    </div>
                  </div>
                  {/* <!-- Total --> */}
                  <div className=" dark:border-black-green border-light-grey mb-2 flex items-center justify-between py-5">
                    <span className="font-display text-dark-navy hover:text-accent font-semibold dark:text-white">
                      Total Offer
                    </span>
                    <div className="ml-auto">
                      <span className="flex items-center whitespace-nowrap">
                        <span className="dark:text-white font-bold tracking-tight">
                          {formatPrice(offer?.totalPrice)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                          {offer?.Currency?.symbol}
                        </span>
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <Notification item={item} isSuccess={isSuccess} isError={isError} />
              )}
            </div>
            {/* <!-- end body --> */}

            <div
              className={`modal-footer dark:!border-black-green !border-light-grey text-center ${
                isSuccess || isError ? 'hidden' : 'block'
              }`}
            >
              <button
                disabled={loading}
                onClick={_acceptOffer}
                className={` rounded-full py-3 px-8 text-center font-semibold  transition-all border  ${
                  loading
                    ? 'dark:bg-black-green bg-white dark:text-grey border dark:border-transparent border-light-grey'
                    : 'bg-green-gradation-light border-transparent text-white'
                }`}
              >
                {loading ? (
                  <div className="flex items-center">
                    <CircularProgress className="!text-grey !h-4 !w-4 mr-2" />
                    <span>Processing...</span>
                  </div>
                ) : (
                  'Accept Offer'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Notification = ({
  item,
  isSuccess,
  isError,
}: {
  item: ItemInterface | undefined;
  isSuccess: boolean;
  isError: boolean;
}) => {
  const [url, setUrl] = useState<string>();
  const [copied, setCopied] = useState<boolean>(false);

  const handleShare = (type: string) => {
    if (type === 'facebook') {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
    } else if (type === 'twitter') {
      window.open(`https://twitter.com/intent/tweet?text=${url}`);
    } else if (type === 'telegram') {
      window.open(`https://t.me/share/url?url=${url}`);
    }
  };

  useEffect(() => {
    if (copied)
      setTimeout(() => {
        setCopied(false);
      }, 3000);
  }, [copied]);

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <div className="w-full ">
      <div className="w-[218px] h-[218px] mb-9 mx-auto">
        <div
          className="w-full pb-[100%] bg-center bg-no-repeat bg-cover rounded-3xl mx-auto"
          style={{backgroundImage: `url('${resolveImage(item?.image as string)}')`}}
        ></div>
      </div>
      <div className="text-base text-center mb-9">
        {isSuccess
          ? 'You have successfully accept this offer'
          : isError
          ? 'You have failed to accept this offer'
          : ''}
      </div>
      <div className={`flex items-center gap-x-6 justify-center ${isError && 'hidden'}`}>
        <div className="text-[10px] text-grey dark:text-light-grey">SHARE</div>
        <Tippy
          hideOnClick={false}
          content={copied ? <span>copied</span> : <span>copy</span>}
          className="p-2"
        >
          <button className="js-copy-clipboard dark:text-jacarta-200 max-w-[10rem] select-none overflow-hidden text-ellipsis whitespace-nowrap">
            <CopyToClipboard text={url ?? ''} onCopy={() => setCopied(true)}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2869 8.71333C10.6043 8.03103 9.67871 7.64774 8.71358 7.64774C7.74846 7.64774 6.82284 8.03103 6.14025 8.71333L3.56608 11.2867C2.88348 11.9693 2.5 12.8951 2.5 13.8604C2.5 14.8258 2.88348 15.7516 3.56608 16.4342C4.24868 17.1168 5.17449 17.5002 6.13983 17.5002C7.10518 17.5002 8.03098 17.1168 8.71358 16.4342L10.0002 15.1475"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stroke-black dark:stroke-[#DEE6E2]"
                />
                <path
                  d="M8.71289 11.2867C9.39548 11.969 10.3211 12.3523 11.2862 12.3523C12.2513 12.3523 13.177 11.969 13.8596 11.2867L16.4337 8.71333C17.1163 8.03073 17.4998 7.10493 17.4998 6.13958C17.4998 5.17424 17.1163 4.24843 16.4337 3.56583C15.7511 2.88323 14.8253 2.49975 13.86 2.49975C12.8946 2.49975 11.9688 2.88323 11.2862 3.56583L9.99956 4.8525"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="stroke-black dark:stroke-[#DEE6E2]"
                />
              </svg>
            </CopyToClipboard>
          </button>
        </Tippy>
        <button onClick={() => handleShare('facebook')}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-light-grey"
          >
            <path d="M7.48186 20V10.6154H5V7.23652H7.48186V4.3505C7.48186 2.08264 8.9479 0 12.326 0C13.6937 0 14.7051 0.1311 14.7051 0.1311L14.6254 3.28642C14.6254 3.28642 13.594 3.27638 12.4684 3.27638C11.2502 3.27638 11.055 3.83768 11.055 4.7693V7.23652H14.7222L14.5627 10.6154H11.055V20H7.48186Z" />
          </svg>
        </button>
        <button onClick={() => handleShare('twitter')}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-light-grey"
          >
            <path d="M19.7029 4.11417C19.0071 4.4225 18.2596 4.63083 17.4737 4.725C18.2846 4.23983 18.8912 3.47622 19.1804 2.57667C18.4186 3.02916 17.5849 3.34766 16.7154 3.51833C16.1307 2.89405 15.3563 2.48027 14.5124 2.34123C13.6684 2.20218 12.8022 2.34566 12.0481 2.74938C11.2941 3.1531 10.6944 3.79447 10.3422 4.57392C9.99003 5.35337 9.90503 6.22729 10.1004 7.06C8.55682 6.9825 7.04677 6.58129 5.66827 5.88242C4.28977 5.18355 3.07362 4.20263 2.09875 3.00333C1.76542 3.57833 1.57375 4.245 1.57375 4.955C1.57338 5.59416 1.73078 6.22354 2.03198 6.78728C2.33319 7.35102 2.76888 7.8317 3.30042 8.18667C2.68398 8.16705 2.08114 8.00049 1.54208 7.70083V7.75083C1.54202 8.64728 1.85211 9.51615 2.41974 10.21C2.98736 10.9038 3.77756 11.3799 4.65625 11.5575C4.0844 11.7123 3.48486 11.7351 2.90292 11.6242C3.15083 12.3955 3.63375 13.07 4.28406 13.5533C4.93437 14.0365 5.71951 14.3043 6.52958 14.3192C5.15444 15.3987 3.45616 15.9842 1.70792 15.9817C1.39823 15.9818 1.08881 15.9637 0.78125 15.9275C2.55581 17.0685 4.62153 17.674 6.73125 17.6717C13.8729 17.6717 17.7771 11.7567 17.7771 6.62667C17.7771 6.46 17.7729 6.29167 17.7654 6.125C18.5248 5.57581 19.1803 4.89575 19.7013 4.11667L19.7029 4.11417Z" />
          </svg>
        </button>
        <button onClick={() => handleShare('telegram')}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-light-grey"
          >
            <path d="M19.9412 3.11411L16.9234 17.3463C16.6957 18.3507 16.1019 18.6007 15.2582 18.1275L10.66 14.7391L8.44124 16.873C8.1957 17.1186 7.99034 17.3239 7.51713 17.3239L7.84749 12.6409L16.3698 4.94001C16.7403 4.60965 16.2894 4.42661 15.7939 4.75697L5.2582 11.3909L0.722485 9.97126C-0.264122 9.66322 -0.281979 8.98465 0.927842 8.51144L18.6689 1.67661C19.4903 1.36858 20.2091 1.85965 19.9412 3.11411Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AcceptOfferModal;
